import { openLink, openTelegramLink } from '@telegram-apps/sdk-react';

/**
 * Внешняя ссылка (страница оплаты). В Telegram — его встроенным браузером
 * (`openLink`), вне Telegram — новой вкладкой. Звать из обработчика тапа:
 * Mini App без действия человека ссылку может и не открыть.
 */
export function openExternal(url: string): void {
  if (openLink.isAvailable()) openLink(url);
  else window.open(url, '_blank', 'noopener');
}

/**
 * Ссылка `t.me/…` (чат, канал): Telegram открывает её у себя, мини-апп при
 * этом сворачивается, а не уходит во внешний браузер.
 */
export function openTelegram(url: string): void {
  if (openTelegramLink.isAvailable()) openTelegramLink(url);
  else window.open(url, '_blank', 'noopener');
}
